import enArrearsInquiryPage from 'Feature/Arrears/components/ArrearsInquiryPage/ui/locales/en.json';
import frArrearsInquiryPage from 'Feature/Arrears/components/ArrearsInquiryPage/ui/locales/fr.json';
import enArrearsManualChangesSection from 'Feature/Arrears/components/ArrearsErrorRecord/ManualChanges/ui/locales/en.json';
import frArrearsManualChangesSection from 'Feature/Arrears/components/ArrearsErrorRecord/ManualChanges/ui/locales/fr.json';
import enFooter from 'Feature/V2/HbtFooter/components/HbtFooterComponent/locales/en.json';
import frFooter from 'Feature/V2/HbtFooter/components/HbtFooterComponent/locales/fr.json';
import enHeader from 'Feature/V2/HbtHeader/components/HbtHeaderComponent/locales/en.json';
import frHeader from 'Feature/V2/HbtHeader/components/HbtHeaderComponent/locales/fr.json';
import enMasterPoolDetails from 'Feature/V2/HbtMasterPool/components/HbtMasterPoolDetails/locales/en.json';
import frMasterPoolDetails from 'Feature/V2/HbtMasterPool/components/HbtMasterPoolDetails/locales/fr.json';
import enMasterPool from 'Feature/V2/HbtMasterPool/locales/en.json';
import frMasterPool from 'Feature/V2/HbtMasterPool/locales/fr.json';
import enPortfolioManagementRequestOverview from 'Feature/V2/HbtPortfolioManagement/components/HbtPortfolioManagementRequestOverview/locales/en.json';
import frPortfolioManagementRequestOverview from 'Feature/V2/HbtPortfolioManagement/components/HbtPortfolioManagementRequestOverview/locales/fr.json';
import enPortfolioManagementPage from 'Feature/V2/HbtPortfolioManagement/locales/en.json';
import frPortfolioManagementPage from 'Feature/V2/HbtPortfolioManagement/locales/fr.json';

import enSharedPortfolio from 'Feature/V2/Shared_Portfolio/locales/en.json';
import frSharedPortfolio from 'Feature/V2/Shared_Portfolio/locales/fr.json';
import enPortfolioManagementSearchResultPage from 'Feature/V2/HbtPortfolioManagement/components/HbtPortfolioManagementPage/pages/HbtPortfolioManagementSearchResultsPage/locales/en.json';
import frPortfolioManagementSearchResultPage from 'Feature/V2/HbtPortfolioManagement/components/HbtPortfolioManagementPage/pages/HbtPortfolioManagementSearchResultsPage/locales/fr.json';
import enMasterPoolSearchResultPage from 'Feature/V2/HbtMasterPool/components/HbtMasterPool/pages/HbtMasterPoolSearchResultsPage/locales/en.json';
import frMasterPoolSearchResultPage from 'Feature/V2/HbtMasterPool/components/HbtMasterPool/pages/HbtMasterPoolSearchResultsPage/locales/fr.json';

import enMasterPoolPricingScenarioPage from 'Feature/V2/HbtMasterPool/components/HbtMasterPool/pages/HbtMasterPoolPricingScenarios/locales/en.json';
import frMasterPoolPricingScenarioPage from 'Feature/V2/HbtMasterPool/components/HbtMasterPool/pages/HbtMasterPoolPricingScenarios/locales/fr.json';
export interface TranslationResources {
  en: Record<string, any>;
  fr: Record<string, any>;
}

export const featureTranslations: TranslationResources = {
  en: {
    HbtHeader: enHeader,
    HbtFooter: enFooter,
    HbtPortfolioManagementPage: enPortfolioManagementPage,
    HbtPortfolioManagementSearchResultPage: enPortfolioManagementSearchResultPage,
    HbtPortfolioManagementRequestOverview: enPortfolioManagementRequestOverview,
    HbtMasterPool: enMasterPool,
    HbtMasterPoolSearchResultPage: enMasterPoolSearchResultPage,
    HbtMasterPoolDetails: enMasterPoolDetails,
    HbtMasterPoolPricingScenario: enMasterPoolPricingScenarioPage,
    HbtArrearsInquiryPage: enArrearsInquiryPage,
    HbtArrearsManualChangesSection: enArrearsManualChangesSection,
    SharedPortfolio: enSharedPortfolio
  },
  fr: {
    HbtHeader: frHeader,
    HbtFooter: frFooter,
    HbtPortfolioManagementPage: frPortfolioManagementPage,
    HbtPortfolioManagementSearchResultPage: frPortfolioManagementSearchResultPage,
    HbtPortfolioManagementRequestOverview: frPortfolioManagementRequestOverview,
    HbtMasterPool: frMasterPool,
    HbtMasterPoolSearchResultPage: frMasterPoolSearchResultPage,
    HbtMasterPoolDetails: frMasterPoolDetails,
    HbtMasterPoolPricingScenario: frMasterPoolPricingScenarioPage,
    HbtArrearsInquiryPage: frArrearsInquiryPage,
    HbtArrearsManualChangesSection: frArrearsManualChangesSection,
    SharedPortfolio: frSharedPortfolio
  }
};
